import React from 'react'
import SponsersSection from '../components/SponsersSection'

export default function SponsersPage() {
  return (
    <SponsersSection isHomePage={false} />
  )
}
